import { ArticleCommentsTopTabRenderProps } from "../articleCommentsTopTabWrapper"
import { getTranslation } from "../translations"
import { getTalkbackNumberView } from "../../articleSocialShare1280Component/articleSocialShareNew1280";


interface ArticleCommentsTopTabUI2026rops {
    props: ArticleCommentsTopTabRenderProps
}

export class ArticleCommentsTopTabUI2026 extends React.Component<ArticleCommentsTopTabUI2026rops, {}>{
    private handleAriaHidden = (isHidden: boolean) => {
        const popup = document.getElementById('ArticleCommentsPopup');
        if (!popup) return;
        
        let parent = popup.parentElement;
        if (!parent) return;
        
        Array.from(parent.children).forEach(el => {
            if (el !== popup) {
                if (isHidden) {
                    el.setAttribute('aria-hidden', 'true');
                } else {
                    el.removeAttribute('aria-hidden');
                }
            }
        });
    }

    private handleOnAddCommentBtnPress = () => {
        const { handleFormVisibility, handleCommentsPopupVisibility } = this.props.props
        handleCommentsPopupVisibility()
        handleFormVisibility()
        
        // Add aria-hidden to siblings when opening
        this.handleAriaHidden(true);
    }

    private handleOnCommentPopupOpen = () => {
        const { handleCommentsPopupVisibility } = this.props.props
        handleCommentsPopupVisibility()
        
        // Add aria-hidden to siblings when opening
        this.handleAriaHidden(true);
    }

    private handleOnCommentPopupClose = () => {
        const { handleCommentsPopupVisibility } = this.props.props
        handleCommentsPopupVisibility()
        
        // Remove aria-hidden from siblings when closing
        this.handleAriaHidden(false);
    }
    render() {
        const { lang, isLtr, numOfComments, isAddCommentFormVisible } = this.props.props
        return (
            <div className="ArticleCommentsTopTabUI2026">

                <div className="tabTitle" onClick={this.handleOnCommentPopupOpen}>
                    <span className="tbIcon"/>
                    <span>{getTalkbackNumberView(numOfComments.toString())} {getTranslation(lang, "Comments")}</span>
                    </div>
                <div className="tabPanel">
                     <button
                        key="newCommentBtn"
                        className="newCommentBtn"
                        title={getTranslation(lang, "New Comment")}
                        disabled={false}
                        onClick={this.handleOnAddCommentBtnPress}>
                        <span>{getTranslation(lang, "New Comment(premium)")}</span>
                    </button>
                </div>
            </div >
        )
    }
}